import Marquee from "react-fast-marquee";
import { SERVICOS } from "@/lib/constants";

export const ServiceMarquee = () => (
  <div data-testid="service-marquee" className="border-y border-slate-200 bg-white py-5">
    <Marquee speed={32} gradient gradientColor="#ffffff" gradientWidth={80} autoFill>
      {SERVICOS.map((s) => (
        <span key={s} className="flex items-center font-heading uppercase tracking-[0.2em] text-xs sm:text-sm text-slate-500 mx-6">
          {s}
          <span className="ml-12 w-1.5 h-1.5 rounded-full bg-[#2E9FDB]/50 inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
